import { jaanUserId } from "@lib/constants";

export function canViewSpeculationSettlements(
  userId: string,
  isAdmin: boolean,
): boolean {
  return userId === jaanUserId || isAdmin;
}
